import HexCard from "../../../../../components/HexCard";
import DetailPreview from "../../../../../components/Preview/DetailPreview";
import { prepareCartTotal } from "../cart-details-utils";

const TotalInformationCard = (amountProps) => {
  const { className, borderless, ...restProps } = amountProps;

  return (
    <HexCard
      className={`content-card information-card ${className} ${
        !borderless ? "br0  card-bottom-divider" : ""
      }`}
    >
      <DetailPreview
        inlineFlex={true}
        className={
          "full-width font-14-regular-400-lh-22 total-information-preview"
        }
        labelClass={"font-20-bold-500"}
        detailInfo={prepareCartTotal(restProps)}
      />
    </HexCard>
  );
};

export default TotalInformationCard;
